var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewToSea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.7693L2.31672 15.6476C2.93575 16.0605 3.73281 16.0956 4.38573 15.7387L5.08865 15.3545C5.74199 14.9974 6.54287 15.05 7.14381 15.4897L7.22279 15.5474C7.85105 16.007 8.71442 15.9998 9.34268 15.5402V15.5402C9.96338 15.0861 10.8173 15.0823 11.4344 15.5411V15.5411C12.0556 16.003 12.9093 16.0007 13.5305 15.5388V15.5388C14.1453 15.0816 14.9881 15.0713 15.6116 15.5167L15.683 15.5677C16.3125 16.0172 17.158 16.0172 17.7874 15.5677L17.8996 15.4876C18.4941 15.0629 19.2986 15.0861 19.8676 15.5443V15.5443C20.4367 16.0024 21.2412 16.0256 21.8356 15.601L23 14.7693M3.32366 18.4503L4.95973 19.3781C5.62996 19.7581 6.45892 19.7194 7.09079 19.2785L7.22182 19.1871C7.85298 18.7467 8.69898 18.7609 9.31839 19.2177V19.2177C9.94659 19.681 10.8077 19.6842 11.4359 19.2209V19.2209C12.0585 18.7617 12.9065 18.7573 13.5339 19.2099L13.5611 19.2295C14.199 19.6896 15.0598 19.6896 15.6977 19.2295L15.7364 19.2016C16.3583 18.753 17.1976 18.753 17.8195 19.2016V19.2016C18.4725 19.6727 19.3605 19.6467 19.985 19.1383L20.8301 18.4503",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86691 13.5468V13.3751C7.86691 11.0496 9.75214 9.16432 12.0777 9.16432V9.16432C14.4032 9.16432 16.2885 11.0496 16.2885 13.3751V13.5468M5.67507 12.3139H2.49915M12.007 3V6.9831M18.4991 12.3139H21.7375M18.339 6.12958L16.1472 8.59531M5.67507 6.12958L7.86691 8.59531",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewToSea);
export default __webpack_public_path__ + "static/media/view_to_sea.cc780810864eb95a9b16b1d76291a48c.svg";
export { ForwardRef as ReactComponent };